import { ChainID, ChainSubType } from '@ankr.com/chains-list';
import { useMemo } from 'react';

import { SecondaryTabs } from 'modules/common/components/SecondaryTabs';
import { useTabs } from 'modules/common/hooks/useTabs';

import { getChainSubTypeTabs } from './utils/getChainSubTypeTabs';
import { useChainSelectors } from '../ChainSelectorsProvider';
import { useChainSubtypeTabsStyles } from './useChainSubtypeTabsStyles';

interface ChainSubtypeTabsProps {
  className?: string;
  classNameTab?: string;
  classNameTabsInner?: string;
  classNameTabsWrapper?: string;
}

export const ChainSubtypeTabs = ({
  className,
  classNameTab,
  classNameTabsInner,
  classNameTabsWrapper,
}: ChainSubtypeTabsProps) => {
  const { chain, chainSubType, setChainSubType } = useChainSelectors();

  const tabs = useMemo(
    () => getChainSubTypeTabs({ chain, onClick: id => setChainSubType(id) }),
    [chain, setChainSubType],
  );

  const [chainSubTypeTabs, chainSubTypeTab] = useTabs({
    initialTabID: chainSubType,
    tabs,
  });

  const visible =
    chainSubType === ChainSubType.Athens3 || chain.id === ChainID.TAC;

  const { classes, cx } = useChainSubtypeTabsStyles();

  return (
    <SecondaryTabs
      className={cx(classes.root, className)}
      classNameTab={classNameTab}
      classNameTabsInner={classNameTabsInner}
      classNameTabsWrapper={classNameTabsWrapper}
      selectedTab={chainSubTypeTab}
      tabs={chainSubTypeTabs}
      visible={visible}
    />
  );
};
